type XStateContextWithErrors = {
  errorMessages: string[]
  errors: { [key: string]: string }
}

type EventWithData = {
  data?: {
    error: any
    errors: { [key: string]: string }
    type?: string
  }
  // XState v5 error structure
  error?: any
  errors?: { [key: string]: string }
  type?: string
}

// this is meant to handle specific field errors that
// are set, then server validation messages, then fallback to
// an exception message, then finally just raw server response
export function setErrorsAction(ctx: XStateContextWithErrors, e: EventWithData) {
  // Handle XState v5 structure (error/type at root level)
  if (e.type === 'validation' || e.error?.type === 'validation') {
    return {
      ...ctx,
      errors: e.errors || e.error?.errors || {}
    }
  }

  // Handle XState v4 structure (backwards compatibility)
  if (e.data?.type === 'validation') {
    return {
      ...ctx,
      errors: e.data.errors
    }
  }

  // Extract error from either v4 or v5 structure
  const errorData = e.error || e.data?.error

  if (errorData || e.data) {
    // Example validation error response:
    // [{"code":"DuplicateEmail","description":"Email 'test@test.com' is already taken."}]
    let errorMessages = []
    if (Array.isArray(errorData)) {
      errorMessages = errorData.map(x => x.description ?? x)
    } else if (errorData?.Message) {
      // Example 500 server response with exception message
      // { Message: "Some error here" }
      errorMessages = [errorData.Message]
    } else if (errorData) {
      errorMessages = [JSON.stringify(errorData)]
    }

    return {
      ...ctx,
      errorMessages
    }
  }
  return {
    ...ctx,
    errorMessages: ['An unknown error occurred']
  }
}
